import styled from "styled-components";

const OvertimeWorkflowDetailsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
    padding: 0rem 1rem 0.8rem;
    box-sizing: border-box;
    overflow: hidden auto;
    font-size: 18px;
    font-family: "Source Sans Pro";
`;

const OvertimeWorkflowDetailsHeader = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;

    > h1 {
        font-family: "Source Sans Pro";
        font-style: normal;
        font-weight: 800;
        font-size: 22px;
        line-height: 32px;
        color: #1e1e1e;
        margin: 0;
        padding: 0;
        margin-bottom: 1rem;
    }

    > div {
        display: flex;
        flex-direction: row;
        justify-content: center;
        align-items: center;

        > p {
            font-family: "Source Sans Pro";
            font-style: normal;
            font-weight: 600;
            font-size: 15px;
            color: #1e1e1e;
            margin: 0;
            padding: 0;

            &:first-child {
                margin-right: 5rem;
            }

            > svg {
                margin-right: 1rem;
            }
        }
    }

    & .overtime_information_header {
        margin-top: 1rem;
    }
`;

const OvertimeWorkflowDetailsBody = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    margin-top: 1rem;

    > table {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        width: 100%;
        margin-bottom: 1rem;

        > tbody {
            display: flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            width: 100%;
            margin: 0;
            padding: 0;

            > tr {
                display: flex;
                flex-direction: row;
                justify-content: flex-start;
                align-items: center;
                width: 100%;
                height: 48px;
                margin: 0;
                padding: 0;
                margin-bottom: 16px;

                & .table_firts_column {
                    width: 40%;
                    max-width: 218px;
                    align-items: flex-start;
                    /* border: 1px solid black; */
                }

                > td {
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: flex-start;
                    width: 100%;
                    margin: 0;
                    padding: 0;
                    text-align: left;
                    height: 48px;

                    > div {
                        margin-bottom: 0 !important;
                    }
                }

                > td.checkbox_wrapper {
                    display: flex;
                    flex-direction: row !important;
                    align-self: center;
                    justify-self: flex-start;
                    justify-content: flex-start;
                    align-items: center;
                }
            }
        }
    }
`;

const OvertimeWorkflowDetailsTextWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 0;
    box-sizing: border-box;
    overflow: hidden auto;
    font-size: 18px;
    font-family: "Source Sans Pro";

    > p {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-weight: 700;
    }

    > span {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        font-weight: 400;
        font-size: 17px;
    }

    > div {
        width: 100%;
    }
`;

const OvertimeWorkflowDetailsButtonsWrapper = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;
    width: 100%;

    > button {
        margin-top: 1rem;
    }
`;

export {
    OvertimeWorkflowDetailsWrapper,
    OvertimeWorkflowDetailsHeader,
    OvertimeWorkflowDetailsBody,
    OvertimeWorkflowDetailsButtonsWrapper,
    OvertimeWorkflowDetailsTextWrapper,
};
